import { useQuery } from "@tanstack/react-query";
import { getCashProducts } from "src/api/wallet";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetCashProducts = ()=>{
    return useQuery({
        queryKey: [
            QUERY_KEYS.CASH_PRODUCT_LIST
        ],
        queryFn: getCashProducts
    });
};
export default useGetCashProducts;
